import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

function Support() {
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Construct mailto link
    const body = `Name: ${name}\n\n${message}`;
    const mailtoLink = `mailto:support@woleh.com?subject=${encodeURIComponent(subject || 'Support Request')}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="support-page">
      <div className="container">
        <div className="support-branding">
          <Link to="/" className="support-home-link">
            <img src="/img/logo.png" alt="KenkoSnap Logo" className="support-logo" />
            <span className="support-brand-name">KenkoSnap</span>
          </Link>
        </div>
        <h1>Contact Support</h1>
        <p>If you have any questions or issues, please fill out the form below and we'll get back to you as soon as possible.</p>
        <form className="support-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              rows="5"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="primary-button">Send Email</button>
        </form>
      </div>
    </div>
  );
}

export default Support; 